// Exports
export default {
	"artifact": "artifact_BCd-I",
	"left": "left_y9XBk"
};
